import { render, staticRenderFns } from "./ActividadesComponent.vue?vue&type=template&id=7f4a4e14&scoped=true&"
import script from "./ActividadesComponent.vue?vue&type=script&lang=ts&"
export * from "./ActividadesComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ActividadesComponent.vue?vue&type=style&index=0&id=7f4a4e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4a4e14",
  null
  
)

export default component.exports